// extracted by mini-css-extract-plugin
export default {"counter":"coinflip-counter_counter__-UWid"};